<template>
	<div>
		<h5 class="resume-title">
			{{$t('account/bookings.Your informations')}}
		</h5>

		<div class="list-group list-group-flush">

			<list-group-item 
			:title="$t('account/bookings.Truck')">
				{{truck}}
			</list-group-item>

			<list-group-item 
			:title="$t('account/bookings.Crossing date')">
				{{booking.data.crossing_date || '-'}}
			</list-group-item>

			<list-group-item 
			:title="$t('account/bookings.Reference')">
				{{booking.reference || '-'}}
			</list-group-item>

			<list-group-item 
			:title="$t('account/bookings.Notes')">
				<nl2br 
				tag="p" 
				:class-name="booking.notes.length > 60 ? 'mt-3' : 'mb-0'"
				:text="booking.notes || '-'" />
			</list-group-item>

		</div> <!-- /.list-group -->

	</div>
</template>

<script>

	import {mapState, mapGetters} from 'vuex'

	export default {

		computed: {

			...mapState({
				booking: state => state.booking
			}),

			...mapGetters('booking', [
				'truck'
			])

		}
		
	}
</script>